import { Pipe, PipeTransform } from '@angular/core';
import { accountingName } from '../utils/accounting-name';

/**
 * Canonical display label for a Party in pickers / typeaheads.
 *
 * "Legal Name - Accounting Company Name" when the party has an accounting name
 * (entered, else NetSuite's print-on-check-as — see `accountingName`), otherwise
 * just the legal name. Two parties can share
 * a legal name (or have near-identical ones), so the accounting name is what
 * lets a user tell them apart while searching.
 *
 * The accounting name is suppressed when it's blank or identical to the legal
 * name (case-insensitive) so we never render "Acme Health - Acme Health".
 */
export function partyLabel(party: any): string {
  const name = (party?.name ?? '').toString().trim();
  const accounting = accountingName(party);

  if (!accounting || accounting.toLowerCase() === name.toLowerCase()) {
    return name;
  }
  return name ? `${name} - ${accounting}` : accounting;
}

@Pipe({
  name: 'partyLabel',
  standalone: true
})
export class PartyLabelPipe implements PipeTransform {
  transform(party: any): string {
    return partyLabel(party);
  }
}
